import React from 'react'
import { Mail, Phone, MapPin, Edit } from 'lucide-react'

interface ProfileHeaderProps {
  profile: {
    name: string
    title: string
    email: string
    phone: string
    location: string
  }
}

export function ProfileHeader({ profile }: ProfileHeaderProps) {
  return (
    <div className="card">
      <div className="flex items-center gap-6">
        <div className="w-20 h-20 bg-gradient-to-br from-brand-primary to-brand-accent-600 rounded-full flex items-center justify-center text-brand-dark text-lg font-bold shadow-monumenta-brand">
          {profile.name.split(' ').map(n => n[0]).join('').substring(0, 2)}
        </div>
        
        <div className="flex-1">
          <h1 className="font-display text-2xl font-bold text-white mb-2 bg-gradient-to-r from-white to-brand-gray-light bg-clip-text text-transparent">{profile.name}</h1>
          <h2 className="font-display text-lg text-brand-primary mb-4">{profile.title}</h2>
          <div className="flex flex-wrap items-center gap-4 text-brand-gray-light">
            <div className="flex items-center gap-2 group">
              <Mail className="w-4 h-4 group-hover:text-brand-primary transition-colors duration-200" />
              <span className="text-sm font-body">{profile.email}</span>
            </div>
            <div className="flex items-center gap-2 group">
              <Phone className="w-4 h-4 group-hover:text-brand-primary transition-colors duration-200" />
              <span className="text-sm font-body">{profile.phone}</span>
            </div>
            <div className="flex items-center gap-2 group">
              <MapPin className="w-4 h-4 group-hover:text-brand-primary transition-colors duration-200" />
              <span className="text-sm font-body">{profile.location}</span>
            </div>
          </div>
        </div>

        <div className="flex gap-2">
          <button className="btn-primary flex items-center gap-2">
            <Edit className="w-4 h-4" />
            Editar Perfil
          </button>
        </div>
      </div>
    </div>
  )
}